module.exports = Object.freeze({
  PORTRAIT_READY: 'PORTRAIT_READY'
})
